import { Disclosure } from "@headlessui/react";
import { MinusIcon, PlusIcon } from "@heroicons/react/20/solid";

export default function BasicFilterItem({
  children,
  name,
  active = 0,
  defaultOpen = false,
}) {
  return (
    <Disclosure
      as="div"
      className="border-b border-olaf-green-700 py-4"
      defaultOpen={defaultOpen}
    >
      {({ open }) => (
        <>
          <h3 className="-my-3 flow-root">
            <Disclosure.Button className="flex w-full items-center justify-between py-3 text-sm text-gray-400 hover:text-gray-500">
              <span className="text-base text-olaf-green-700 flex items-center">
                {name}{" "}
                {active.length > 0 && (
                  <span className="ml-2 w-6 h-6 flex justify-center items-center rounded-full bg-olaf-orange-500 text-xs text-white">
                    {active.length}
                  </span>
                )}
              </span>
              <span className="ml-6 flex items-center">
                {open ? (
                  <MinusIcon
                    className="h-5 w-5 text-olaf-green-700"
                    aria-hidden="true"
                  />
                ) : (
                  <PlusIcon
                    className="h-5 w-5 text-olaf-green-700"
                    aria-hidden="true"
                  />
                )}
              </span>
            </Disclosure.Button>
          </h3>
          <Disclosure.Panel className="pt-6">{children}</Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
